import { toURLSearchParams } from '@wix/metro-runtime';
import { serializer } from '@wix/metro-runtime/ambassador';
import { resolveUrl } from '@wix/metro-runtime';
var _getCreditRequest = {};
var _getCreditResponse = {};
var _isEligibleRequest = {};
var _isEligibleResponse = {};
function resolveWixMultilingualMachineV1TranslationCreditsUrl(opts) {
    var domainToMappings = {};
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
/** Gets the credit status for the request msid */
export function getCredit(payload) {
    var _a = serializer(_getCreditRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getCreditResponse, {}).fromJSON;
    function __getCredit(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.multilingual.machine.v1.credit',
            method: 'GET',
            methodFqn: 'wix.multilingual.machine.v1.TranslationCredits.GetCredit',
            url: resolveWixMultilingualMachineV1TranslationCreditsUrl({
                protoPath: '/v1/credit',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getCredit.fromReq = fromReq;
    __getCredit.__isAmbassador = true;
    return __getCredit;
}
/** Returns if a site is eligible for translations of the requested count of words */
export function isEligible(payload) {
    var _a = serializer(_isEligibleRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_isEligibleResponse, {}).fromJSON;
    function __isEligible(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.multilingual.machine.v1.credit',
            method: 'POST',
            methodFqn: 'wix.multilingual.machine.v1.TranslationCredits.IsEligible',
            url: resolveWixMultilingualMachineV1TranslationCreditsUrl({
                protoPath: '/v1/credit/is-eligible',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __isEligible.fromReq = fromReq;
    __isEligible.__isAmbassador = true;
    return __isEligible;
}
//# sourceMappingURL=http.impl.js.map